export function isAbortEndpointMissing(error: unknown): boolean {
  if (error && typeof error === 'object' && 'status' in error) {
    const status = (error as { status?: unknown }).status;
    return status === 404 || status === 405;
  }

  if (error instanceof Error) {
    return /status code (404|405)/i.test(error.message);
  }

  return false;
}

/** The steer endpoint responds 409 when the session has no active run to steer. */
export function isSteerConflict(error: unknown): boolean {
  if (error && typeof error === 'object' && 'status' in error) {
    return (error as { status?: unknown }).status === 409;
  }

  if (error instanceof Error) {
    return /status code 409/i.test(error.message);
  }

  return false;
}
